import { 
  CAP_TABLE_REFERENCE_TITLE, 
  CAP_TABLE_REFERENCE_TYPE, 
  CUSTOM_BREAKPOINTS_REFERENCE_TITLE, 
  CUSTOM_BREAKPOINTS_REFERENCE_TYPE, 
  EXTERNAL_VALUATION_REFERENCE_TITLE, 
  EXTERNAL_VALUATION_REFERENCE_TYPE, 
  FINANCIALS_REFERENCE_TITLE, 
  FINANCIALS_REFERENCE_TYPE, 
  FUND_OWNERSHIP_REFERENCE_TITLE, 
  FUND_OWNERSHIP_REFERENCE_TYPE, 
  SSV_REFERENCE_TITLE, 
  SSV_REFERENCE_TYPE 
} from 'common/constants/documents';
import theme from 'theme';
import { PageReferenceType } from './types';

const referenceTypes: Record<PageReferenceType, string> = {
  [CAP_TABLE_REFERENCE_TYPE]: CAP_TABLE_REFERENCE_TITLE,
  [FUND_OWNERSHIP_REFERENCE_TYPE]: FUND_OWNERSHIP_REFERENCE_TITLE,
  [FINANCIALS_REFERENCE_TYPE]: FINANCIALS_REFERENCE_TITLE,
  [CUSTOM_BREAKPOINTS_REFERENCE_TYPE]: CUSTOM_BREAKPOINTS_REFERENCE_TITLE,
  [EXTERNAL_VALUATION_REFERENCE_TYPE]: EXTERNAL_VALUATION_REFERENCE_TITLE,
  [SSV_REFERENCE_TYPE]: SSV_REFERENCE_TITLE,
};

export const getPageReferenceLabel = (referenceObjectType: PageReferenceType): string => referenceTypes[referenceObjectType];

const PAGE_REFERENCE_COLORS: Record<PageReferenceType, string> = {
  [CAP_TABLE_REFERENCE_TYPE]: theme.palette.error.main,
  [FUND_OWNERSHIP_REFERENCE_TYPE]: theme.palette.warning.main,
  [FINANCIALS_REFERENCE_TYPE]: theme.palette.secondary.main,
  [CUSTOM_BREAKPOINTS_REFERENCE_TYPE]: theme.palette.primary.main,
  [EXTERNAL_VALUATION_REFERENCE_TYPE]: theme.palette.error.pink,
  [SSV_REFERENCE_TYPE]: theme.palette.text.link,
};

const getPageReferenceColor = (referenceObjectType: PageReferenceType): string => PAGE_REFERENCE_COLORS[referenceObjectType] ?? theme.palette.black;

export const getReferenceTypeStyle = (referenceObjectType: PageReferenceType): React.CSSProperties => {
  const referenceColor = getPageReferenceColor(referenceObjectType);
  return {
    color: referenceColor,
    borderColor: referenceColor,
  };
}
  